<template>
  <section class="content">
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      v-on:table-delete-request="deleteEntity"
      v-on:table-edit-request="handleEdit"
      :showEdit="true"
      :showDelete="true"
      :tableData="tableData"
      :tableTitle="'User Groups'"
      :fields="fields"
      v-on:pages-remaining="loadMore"
      :maxItems="maxValue"
    ></vuetable>
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
  export default {
    name: 'UserGroupSearchResults',
    components: {
      vuetable: vuetable,
      Loader
    },
    mixins: [ AdminSearchResults ],
    data () {
      return {
        loading: false,
        tableData: [],
        entityName: 'user-group',
        editEntityScreen: 'Admin - Edit/View User Group',
        fields: [
          { header: 'Name', prop: 'name', hideByDefault: false },
          { header: 'Code', prop: 'code', hideByDefault: false },
          { header: 'Country', prop: item => item.defaultCountry !== null ? item.defaultCountry.code : '', hideByDefault: true },
          { header: 'Currency', prop: item => item.defaultCurrency !== null ? item.defaultCurrency.code : '', hideByDefault: true }
        ]
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// UserGroupSearchResults.vue?ee02225c